import React from 'react';
import {StyleSheet, View} from "react-native";
import {GestureHandlerRootView, LongPressGestureHandler, State} from "react-native-gesture-handler";

import {actuatedNormalize} from "../services/helpers/stylingHelpers";

const HiddenLongPress = ({ onEvent, position = 'bottomLeft' , duration = 3000}) => {
    const _onHandleGestureChange = async ({nativeEvent}) => {
        if (nativeEvent.state === State.ACTIVE) {
            onEvent()
        }
    }

    return (
        <GestureHandlerRootView style={[styles.container, styles[position]]}>
            <LongPressGestureHandler onGestureEvent={_onHandleGestureChange}
                                     onHandlerStateChange={_onHandleGestureChange}
                                     minDurationMs={duration}
                                     maxDist={Number.MAX_SAFE_INTEGER}
                                     shouldCancelWhenOutside={false}
                                     hitSlop={10}>
                <View style={[styles.container, styles[position]]}/>
            </LongPressGestureHandler>
        </GestureHandlerRootView>
    );
};

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        width: actuatedNormalize(100),
        height: actuatedNormalize(100),
        zIndex: 9999
    },
    topRight: {
        top: 0,
        right: 0,
    },
    topLeft: {
        top: 0,
        left: 0,
    },
    bottomRight: {
        bottom: 0,
        right: 0,
    },
    bottomLeft: {
        bottom: 0,
        left: 0,
    },
});

export default HiddenLongPress;
